import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import LinkTextBoxViewModelType from '@/ViewModels/Controls/LinkTextBoxViewModel';
import LinkType from '@/Controls/Link';
import TextBoxType from '@/Controls/TextBox';

export default class LinkTextBox extends Control {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private TextBox = ComponentManager.getControl<typeof TextBoxType>('TextBox');
    private jQueryControl: JQuery;
    private textBox: TextBoxType;
    private link: LinkType;
    private linkChange: LinkType;

    public constructor(private viewModel: LinkTextBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'linktextbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            focus: this.viewModel.isFocusable,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.textBox != null) {
            this.textBox = new this.TextBox(this.viewModel.textBox);
            let tuple = this.textBox.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.link != null) {
            this.link = new this.Link(this.viewModel.link);
            let tuple = this.link.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkChange != null) {
            this.linkChange = new this.Link(this.viewModel.linkChange);
            let tuple = this.linkChange.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }

    public addLabelReference(label: JQuery): JQuery {
        return this.textBox.addLabelReference(label);
    }
}

ComponentManager.setControl('LinkTextBox', LinkTextBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');